import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { Container, Item } from 'Components/Grid';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import HistorySection from 'Components/HistorySection';
import InfoPopover from 'Components/InfoPopover';
import DocumentCreationButton from 'Components/DocumentCreationButton';
import { ftmtrs } from 'neuro-schemas';

const {
  calculators: { calculateFTMTRSScore },
} = ftmtrs;

const PartBScore = ({ document }: IPartBScore) => {
  const whichHand = document.whichHand;

  const score = calculateFTMTRSScore<'b'>(document, 'b');

  const rightScore = score && 'right' in score ? (score.right ?? null) : null;

  const leftScore = score && 'left' in score ? (score.left ?? null) : null;

  return !whichHand ? (
    <InfoPopover text="general.notFilled" color="primary" />
  ) : (
    <Container style={{ fontWeight: 600 }}>
      {(whichHand === 'both' || whichHand === 'right') && (
        <Item xs={6}>
          <FormattedMessage id="general.right" />:
          <span style={{ marginLeft: '1rem' }}>
            {rightScore ?? <InfoPopover text="general.notFilled" color="primary" />}
          </span>
        </Item>
      )}
      {(whichHand === 'both' || whichHand === 'left') && (
        <Item xs={6}>
          <FormattedMessage id="general.left" />:
          <span style={{ marginLeft: '1rem' }}>
            {leftScore ?? <InfoPopover text="general.notFilled" color="primary" />}
          </span>
        </Item>
      )}
    </Container>
  );
};
interface IPartBScore {
  document: IFTMTRS;
}

const FTMTRS = ({ documents, startEdit, view }: IOwnProps): React.JSX.Element => {
  return (
    <HistorySection
      headerText={<FormattedMessage id={'updrs.ftmtrs'} />}
      newButton={
        <DocumentCreationButton
          name="ftmtrs"
          text={'updrs.newftmtrs'}
          onClick={startEdit({}, 'ftmtrs')}
          width={15}
          height={3}
          fontSize={14}
          alternate={true}
        />
      }
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <>
            <Item xs={4}>
              <FormattedMessage id={'updrs.labels.ftmtrs.subtotalA'} />
            </Item>
            <Item xs={4}>
              <FormattedMessage id={'updrs.labels.ftmtrs.subtotalB'} />
            </Item>
            <Item xs={4}>
              <FormattedMessage id={'updrs.labels.ftmtrs.subtotalC'} />
            </Item>
          </>
        }
        contentFormat={d => (
          <>
            <Item xs={4}>
              {calculateFTMTRSScore<'a'>(d, 'a') || calculateFTMTRSScore<'a'>(d, 'a') === 0 ? (
                calculateFTMTRSScore<'a'>(d, 'a')
              ) : (
                <InfoPopover text="general.notFilled" color="primary" />
              )}
            </Item>
            <Item xs={4}>
              <PartBScore document={d} />
            </Item>
            <Item xs={4}>
              {calculateFTMTRSScore<'c'>(d, 'c') || calculateFTMTRSScore<'c'>(d, 'c') === 0 ? (
                calculateFTMTRSScore<'c'>(d, 'c')
              ) : (
                <InfoPopover text="general.notFilled" color="primary" />
              )}
            </Item>
          </>
        )}
        makeDate
        makeControls
        historyRowControls={d => <HistoryRowControls document={d} startEdit={startEdit} view={view} />}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'ftmtrs'>[];
  startEdit: StartEdit;
  view?: IView;
}

export default FTMTRS;
